import { default as _404lZJpwxvtooMeta } from "/vercel/path0/pages/404.vue?macro=true";
import { default as indexuxbYRerfIgMeta } from "/vercel/path0/pages/auth/completar-cadastro/index.vue?macro=true";
import { default as _91_46_46_46slug_93nEvdtyLe3LMeta } from "/vercel/path0/pages/auth/criar-conta/[...slug].vue?macro=true";
import { default as recuperar_45senhaK7ZaZmFKI3Meta } from "/vercel/path0/pages/auth/recuperar-senha.vue?macro=true";
import { default as sairinb3XYprvrMeta } from "/vercel/path0/pages/auth/sair.vue?macro=true";
import { default as verificarrwZmmxrlUWMeta } from "/vercel/path0/pages/auth/verificar.vue?macro=true";
import { default as paymentuM71ATR39tMeta } from "/vercel/path0/pages/checkout/payment.vue?macro=true";
import { default as contatoDyzjQXAwA4Meta } from "/vercel/path0/pages/contato.vue?macro=true";
import { default as _91id_93_32copyyzMN19i0VvMeta } from "/vercel/path0/pages/evento/[id] copy.vue?macro=true";
import { default as _91id_93_old3HImTN3J5rMeta } from "/vercel/path0/pages/evento/[id]_old.vue?macro=true";
import { default as _91id_93ZXKDoBKjlyMeta } from "/vercel/path0/pages/evento/[id].vue?macro=true";
import { default as eventos5wNgFWOpyxMeta } from "/vercel/path0/pages/eventos.vue?macro=true";
import { default as _91id_categoria_937Zq4iskzArMeta } from "/vercel/path0/pages/explorar/[id_categoria].vue?macro=true";
import { default as indexlN1JVWShKXMeta } from "/vercel/path0/pages/explorar/index.vue?macro=true";
import { default as indexfgiwrlFjmpMeta } from "/vercel/path0/pages/index/index.vue?macro=true";
import { default as _91_46_46_46slug_93OBvQSb1r99Meta } from "/vercel/path0/pages/login/[...slug].vue?macro=true";
import { default as _91id_93a0DPkWfazXMeta } from "/vercel/path0/pages/org/[id].vue?macro=true";
import { default as _91id_org_93oxBJqigW7cMeta } from "/vercel/path0/pages/page/[id_org].vue?macro=true";
import { default as acesso_45negadoc5EkvNX6KxMeta } from "/vercel/path0/pages/painel/acesso-negado.vue?macro=true";
import { default as configynleCaG94IMeta } from "/vercel/path0/pages/painel/config.vue?macro=true";
import { default as extratoihF7J98NrHMeta } from "/vercel/path0/pages/painel/financeiro/extrato.vue?macro=true";
import { default as index8iiswOvHa9Meta } from "/vercel/path0/pages/painel/financeiro/index.vue?macro=true";
import { default as recargaoDiQmeLXD6Meta } from "/vercel/path0/pages/painel/financeiro/recarga.vue?macro=true";
import { default as index4zvfyrDpQuMeta } from "/vercel/path0/pages/painel/index.vue?macro=true";
import { default as configvWXk4MTi2CMeta } from "/vercel/path0/pages/painel/org/[id]/bar/[id_bar]/config.vue?macro=true";
import { default as equiped1gQAKJkfWMeta } from "/vercel/path0/pages/painel/org/[id]/bar/[id_bar]/equipe.vue?macro=true";
import { default as estoque4bX0nZV4lUMeta } from "/vercel/path0/pages/painel/org/[id]/bar/[id_bar]/estoque.vue?macro=true";
import { default as indexkYCCGXnML6Meta } from "/vercel/path0/pages/painel/org/[id]/bar/[id_bar]/index.vue?macro=true";
import { default as nfcRhyy64SDXPMeta } from "/vercel/path0/pages/painel/org/[id]/bar/[id_bar]/nfc.vue?macro=true";
import { default as pedidosHfU8sT6evPMeta } from "/vercel/path0/pages/painel/org/[id]/bar/[id_bar]/pedidos.vue?macro=true";
import { default as produtosi20rQ067iuMeta } from "/vercel/path0/pages/painel/org/[id]/bar/[id_bar]/produtos.vue?macro=true";
import { default as addLLsyfNtS8fMeta } from "/vercel/path0/pages/painel/org/[id]/bares/add.vue?macro=true";
import { default as indexTw3NymArFzMeta } from "/vercel/path0/pages/painel/org/[id]/bares/index.vue?macro=true";
import { default as add0BWmCMWOudMeta } from "/vercel/path0/pages/painel/org/[id]/comercio/[id_comercio]/cardapio/add.vue?macro=true";
import { default as indexnqbotXRSctMeta } from "/vercel/path0/pages/painel/org/[id]/comercio/[id_comercio]/cardapio/index.vue?macro=true";
import { default as configMHPf1Okjk9Meta } from "/vercel/path0/pages/painel/org/[id]/comercio/[id_comercio]/config.vue?macro=true";
import { default as editarpljlpY0TV4Meta } from "/vercel/path0/pages/painel/org/[id]/comercio/[id_comercio]/editar.vue?macro=true";
import { default as index2WYERBhzSUMeta } from "/vercel/path0/pages/painel/org/[id]/comercio/[id_comercio]/index.vue?macro=true";
import { default as addLsvbJK6yImMeta } from "/vercel/path0/pages/painel/org/[id]/comercios/add.vue?macro=true";
import { default as indexRFl9pdfKErMeta } from "/vercel/path0/pages/painel/org/[id]/comercios/index.vue?macro=true";
import { default as indexpj2zVkUUbIMeta } from "/vercel/path0/pages/painel/org/[id]/comunicacao/index.vue?macro=true";
import { default as configW3z2aF5a2AMeta } from "/vercel/path0/pages/painel/org/[id]/config.vue?macro=true";
import { default as documentosJJAmKmpLUmMeta } from "/vercel/path0/pages/painel/org/[id]/conta/documentos.vue?macro=true";
import { default as indexVhnntHz4jXMeta } from "/vercel/path0/pages/painel/org/[id]/evento/[id_evento]/checkin/index.vue?macro=true";
import { default as config1grE2hYwYzMeta } from "/vercel/path0/pages/painel/org/[id]/evento/[id_evento]/config.vue?macro=true";
import { default as addaxfbpMiRxKMeta } from "/vercel/path0/pages/painel/org/[id]/evento/[id_evento]/cupons/add.vue?macro=true";
import { default as _91id_cupom_93puf2HjdmwlMeta } from "/vercel/path0/pages/painel/org/[id]/evento/[id_evento]/cupons/editar/[id_cupom].vue?macro=true";
import { default as indexzCTy21aqlhMeta } from "/vercel/path0/pages/painel/org/[id]/evento/[id_evento]/cupons/index.vue?macro=true";
import { default as editarZf334ZnpyiMeta } from "/vercel/path0/pages/painel/org/[id]/evento/[id_evento]/editar.vue?macro=true";
import { default as historicoxSpBBWefJgMeta } from "/vercel/path0/pages/painel/org/[id]/evento/[id_evento]/financeiro/historico.vue?macro=true";
import { default as indexYvMGntbFSCMeta } from "/vercel/path0/pages/painel/org/[id]/evento/[id_evento]/financeiro/index.vue?macro=true";
import { default as indexnDk5as1xkAMeta } from "/vercel/path0/pages/painel/org/[id]/evento/[id_evento]/index.vue?macro=true";
import { default as addPn4vKNUrd9Meta } from "/vercel/path0/pages/painel/org/[id]/evento/[id_evento]/ingressos/add.vue?macro=true";
import { default as _91id_ingresso_93B7Ul2JVumZMeta } from "/vercel/path0/pages/painel/org/[id]/evento/[id_evento]/ingressos/editar/[id_ingresso].vue?macro=true";
import { default as indexuIFaoGHbubMeta } from "/vercel/path0/pages/painel/org/[id]/evento/[id_evento]/ingressos/index.vue?macro=true";
import { default as integracoesphgQWoAfkmMeta } from "/vercel/path0/pages/painel/org/[id]/evento/[id_evento]/integracoes.vue?macro=true";
import { default as email2KsQJuwgutMeta } from "/vercel/path0/pages/painel/org/[id]/evento/[id_evento]/participantes/email.vue?macro=true";
import { default as indexc52B41BvMQMeta } from "/vercel/path0/pages/painel/org/[id]/evento/[id_evento]/participantes/index.vue?macro=true";
import { default as preferenciasK77pg4EtLSMeta } from "/vercel/path0/pages/painel/org/[id]/evento/[id_evento]/preferencias.vue?macro=true";
import { default as add0eU2CF7zXmMeta } from "/vercel/path0/pages/painel/org/[id]/eventos/add.vue?macro=true";
import { default as indexdK3HQeP289Meta } from "/vercel/path0/pages/painel/org/[id]/eventos/index.vue?macro=true";
import { default as indexdKj6PymhY1Meta } from "/vercel/path0/pages/painel/org/[id]/financeiro/extrato/index.vue?macro=true";
import { default as indexIfZkta3rYRMeta } from "/vercel/path0/pages/painel/org/[id]/financeiro/index.vue?macro=true";
import { default as indexSgPZUMeb6MMeta } from "/vercel/path0/pages/painel/org/[id]/financeiro/saques/index.vue?macro=true";
import { default as _91id_venda_93aRzTeha3HkMeta } from "/vercel/path0/pages/painel/org/[id]/financeiro/vendas/[id_venda].vue?macro=true";
import { default as indexfiNVcUgN6PMeta } from "/vercel/path0/pages/painel/org/[id]/financeiro/vendas/index.vue?macro=true";
import { default as indexQAdtaf5TRqMeta } from "/vercel/path0/pages/painel/org/[id]/index.vue?macro=true";
import { default as indexoLg7RAfijaMeta } from "/vercel/path0/pages/painel/org/[id]/integracoes/index.vue?macro=true";
import { default as addyMJxC3NlG9Meta } from "/vercel/path0/pages/painel/org/[id]/locais/add.vue?macro=true";
import { default as indexn5WgFWtuL0Meta } from "/vercel/path0/pages/painel/org/[id]/locais/index.vue?macro=true";
import { default as _91id_pedido_934jq3jkYBw6Meta } from "/vercel/path0/pages/painel/org/[id]/pedidos/[id_pedido].vue?macro=true";
import { default as indexki02SufrMCMeta } from "/vercel/path0/pages/painel/org/[id]/pedidos/index.vue?macro=true";
import { default as _91ticket_id_93x3sopNe1prMeta } from "/vercel/path0/pages/painel/org/[id]/suporte/[ticket_id].vue?macro=true";
import { default as indexdid5JBdLeOMeta } from "/vercel/path0/pages/painel/org/[id]/suporte/index.vue?macro=true";
import { default as addkyI3YaxaZ5Meta } from "/vercel/path0/pages/painel/org/add.vue?macro=true";
import { default as suporte7NWhQTjWn1Meta } from "/vercel/path0/pages/painel/suporte.vue?macro=true";
import { default as dadosARNg6LKW21Meta } from "/vercel/path0/pages/perfil/dados.vue?macro=true";
import { default as editar5BJg38phDpMeta } from "/vercel/path0/pages/perfil/editar.vue?macro=true";
import { default as extrato9F4an1sRirMeta } from "/vercel/path0/pages/perfil/extrato.vue?macro=true";
import { default as favoritosCx9ddvGebHMeta } from "/vercel/path0/pages/perfil/favoritos.vue?macro=true";
import { default as indexvl9E5kU77iMeta } from "/vercel/path0/pages/perfil/index.vue?macro=true";
import { default as _91id_93UnYx625l00Meta } from "/vercel/path0/pages/perfil/ingressos/[id].vue?macro=true";
import { default as indexcBf6q7NfXaMeta } from "/vercel/path0/pages/perfil/ingressos/index.vue?macro=true";
import { default as notificacoesW2q1tAfYwaMeta } from "/vercel/path0/pages/perfil/notificacoes.vue?macro=true";
import { default as _91id_93ZA2mQ6KzYHMeta } from "/vercel/path0/pages/perfil/pedidos/[id].vue?macro=true";
import { default as indexwmIKiyCcO8Meta } from "/vercel/path0/pages/perfil/pedidos/index.vue?macro=true";
import { default as recargaTzbUxVcUyYMeta } from "/vercel/path0/pages/perfil/recarga.vue?macro=true";
import { default as segurancaEL7YUXohuhMeta } from "/vercel/path0/pages/perfil/seguranca.vue?macro=true";
import { default as suporte9TcKM1paUdMeta } from "/vercel/path0/pages/perfil/suporte.vue?macro=true";
import { default as walletshqp98X6HVMeta } from "/vercel/path0/pages/perfil/wallet.vue?macro=true";
import { default as politicas_45de_45privacidadeLNpncEhE7TMeta } from "/vercel/path0/pages/politicas-de-privacidade.vue?macro=true";
import { default as indexDqV3Lxa5AvMeta } from "/vercel/path0/pages/search/index.vue?macro=true";
import { default as termos_45e_45condicoesbzrt6NyaPIMeta } from "/vercel/path0/pages/termos-e-condicoes.vue?macro=true";
import { default as _91id_93xOysflTcTtMeta } from "/vercel/path0/pages/v/checkout/[id].vue?macro=true";
export default [
  {
    name: _404lZJpwxvtooMeta?.name ?? "404",
    path: _404lZJpwxvtooMeta?.path ?? "/404",
    meta: _404lZJpwxvtooMeta || {},
    alias: _404lZJpwxvtooMeta?.alias || [],
    redirect: _404lZJpwxvtooMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/404.vue").then(m => m.default || m)
  },
  {
    name: indexuxbYRerfIgMeta?.name ?? "auth-completar-cadastro",
    path: indexuxbYRerfIgMeta?.path ?? "/auth/completar-cadastro",
    meta: indexuxbYRerfIgMeta || {},
    alias: indexuxbYRerfIgMeta?.alias || [],
    redirect: indexuxbYRerfIgMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/auth/completar-cadastro/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93nEvdtyLe3LMeta?.name ?? "auth-criar-conta-slug",
    path: _91_46_46_46slug_93nEvdtyLe3LMeta?.path ?? "/auth/criar-conta/:slug(.*)*",
    meta: _91_46_46_46slug_93nEvdtyLe3LMeta || {},
    alias: _91_46_46_46slug_93nEvdtyLe3LMeta?.alias || [],
    redirect: _91_46_46_46slug_93nEvdtyLe3LMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/auth/criar-conta/[...slug].vue").then(m => m.default || m)
  },
  {
    name: recuperar_45senhaK7ZaZmFKI3Meta?.name ?? "auth-recuperar-senha",
    path: recuperar_45senhaK7ZaZmFKI3Meta?.path ?? "/auth/recuperar-senha",
    meta: recuperar_45senhaK7ZaZmFKI3Meta || {},
    alias: recuperar_45senhaK7ZaZmFKI3Meta?.alias || [],
    redirect: recuperar_45senhaK7ZaZmFKI3Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/auth/recuperar-senha.vue").then(m => m.default || m)
  },
  {
    name: sairinb3XYprvrMeta?.name ?? "auth-sair",
    path: sairinb3XYprvrMeta?.path ?? "/auth/sair",
    meta: sairinb3XYprvrMeta || {},
    alias: sairinb3XYprvrMeta?.alias || [],
    redirect: sairinb3XYprvrMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/auth/sair.vue").then(m => m.default || m)
  },
  {
    name: verificarrwZmmxrlUWMeta?.name ?? "auth-verificar",
    path: verificarrwZmmxrlUWMeta?.path ?? "/auth/verificar",
    meta: verificarrwZmmxrlUWMeta || {},
    alias: verificarrwZmmxrlUWMeta?.alias || [],
    redirect: verificarrwZmmxrlUWMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/auth/verificar.vue").then(m => m.default || m)
  },
  {
    name: paymentuM71ATR39tMeta?.name ?? "checkout-payment",
    path: paymentuM71ATR39tMeta?.path ?? "/checkout/payment",
    meta: paymentuM71ATR39tMeta || {},
    alias: paymentuM71ATR39tMeta?.alias || [],
    redirect: paymentuM71ATR39tMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/checkout/payment.vue").then(m => m.default || m)
  },
  {
    name: contatoDyzjQXAwA4Meta?.name ?? "contato",
    path: contatoDyzjQXAwA4Meta?.path ?? "/contato",
    meta: contatoDyzjQXAwA4Meta || {},
    alias: contatoDyzjQXAwA4Meta?.alias || [],
    redirect: contatoDyzjQXAwA4Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/contato.vue").then(m => m.default || m)
  },
  {
    name: _91id_93_32copyyzMN19i0VvMeta?.name ?? "evento-id copy",
    path: _91id_93_32copyyzMN19i0VvMeta?.path ?? "/evento/:id()%20copy",
    meta: _91id_93_32copyyzMN19i0VvMeta || {},
    alias: _91id_93_32copyyzMN19i0VvMeta?.alias || [],
    redirect: _91id_93_32copyyzMN19i0VvMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/evento/[id] copy.vue").then(m => m.default || m)
  },
  {
    name: _91id_93_old3HImTN3J5rMeta?.name ?? "evento-id_old",
    path: _91id_93_old3HImTN3J5rMeta?.path ?? "/evento/:id()_old",
    meta: _91id_93_old3HImTN3J5rMeta || {},
    alias: _91id_93_old3HImTN3J5rMeta?.alias || [],
    redirect: _91id_93_old3HImTN3J5rMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/evento/[id]_old.vue").then(m => m.default || m)
  },
  {
    name: _91id_93ZXKDoBKjlyMeta?.name ?? "evento-id",
    path: _91id_93ZXKDoBKjlyMeta?.path ?? "/evento/:id()",
    meta: _91id_93ZXKDoBKjlyMeta || {},
    alias: _91id_93ZXKDoBKjlyMeta?.alias || [],
    redirect: _91id_93ZXKDoBKjlyMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/evento/[id].vue").then(m => m.default || m)
  },
  {
    name: eventos5wNgFWOpyxMeta?.name ?? "eventos",
    path: eventos5wNgFWOpyxMeta?.path ?? "/eventos",
    meta: eventos5wNgFWOpyxMeta || {},
    alias: eventos5wNgFWOpyxMeta?.alias || [],
    redirect: eventos5wNgFWOpyxMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/eventos.vue").then(m => m.default || m)
  },
  {
    name: _91id_categoria_937Zq4iskzArMeta?.name ?? "explorar-id_categoria",
    path: _91id_categoria_937Zq4iskzArMeta?.path ?? "/explorar/:id_categoria()",
    meta: _91id_categoria_937Zq4iskzArMeta || {},
    alias: _91id_categoria_937Zq4iskzArMeta?.alias || [],
    redirect: _91id_categoria_937Zq4iskzArMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/explorar/[id_categoria].vue").then(m => m.default || m)
  },
  {
    name: indexlN1JVWShKXMeta?.name ?? "explorar",
    path: indexlN1JVWShKXMeta?.path ?? "/explorar",
    meta: indexlN1JVWShKXMeta || {},
    alias: indexlN1JVWShKXMeta?.alias || [],
    redirect: indexlN1JVWShKXMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/explorar/index.vue").then(m => m.default || m)
  },
  {
    name: indexfgiwrlFjmpMeta?.name ?? "index",
    path: indexfgiwrlFjmpMeta?.path ?? "/",
    meta: indexfgiwrlFjmpMeta || {},
    alias: indexfgiwrlFjmpMeta?.alias || [],
    redirect: indexfgiwrlFjmpMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/index/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93OBvQSb1r99Meta?.name ?? "login-slug",
    path: _91_46_46_46slug_93OBvQSb1r99Meta?.path ?? "/login/:slug(.*)*",
    meta: _91_46_46_46slug_93OBvQSb1r99Meta || {},
    alias: _91_46_46_46slug_93OBvQSb1r99Meta?.alias || [],
    redirect: _91_46_46_46slug_93OBvQSb1r99Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/login/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91id_93a0DPkWfazXMeta?.name ?? "org-id",
    path: _91id_93a0DPkWfazXMeta?.path ?? "/org/:id()",
    meta: _91id_93a0DPkWfazXMeta || {},
    alias: _91id_93a0DPkWfazXMeta?.alias || [],
    redirect: _91id_93a0DPkWfazXMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/org/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_org_93oxBJqigW7cMeta?.name ?? "page-id_org",
    path: _91id_org_93oxBJqigW7cMeta?.path ?? "/page/:id_org()",
    meta: _91id_org_93oxBJqigW7cMeta || {},
    alias: _91id_org_93oxBJqigW7cMeta?.alias || [],
    redirect: _91id_org_93oxBJqigW7cMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/page/[id_org].vue").then(m => m.default || m)
  },
  {
    name: acesso_45negadoc5EkvNX6KxMeta?.name ?? "painel-acesso-negado",
    path: acesso_45negadoc5EkvNX6KxMeta?.path ?? "/painel/acesso-negado",
    meta: acesso_45negadoc5EkvNX6KxMeta || {},
    alias: acesso_45negadoc5EkvNX6KxMeta?.alias || [],
    redirect: acesso_45negadoc5EkvNX6KxMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/acesso-negado.vue").then(m => m.default || m)
  },
  {
    name: configynleCaG94IMeta?.name ?? "painel-config",
    path: configynleCaG94IMeta?.path ?? "/painel/config",
    meta: configynleCaG94IMeta || {},
    alias: configynleCaG94IMeta?.alias || [],
    redirect: configynleCaG94IMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/config.vue").then(m => m.default || m)
  },
  {
    name: extratoihF7J98NrHMeta?.name ?? "painel-financeiro-extrato",
    path: extratoihF7J98NrHMeta?.path ?? "/painel/financeiro/extrato",
    meta: extratoihF7J98NrHMeta || {},
    alias: extratoihF7J98NrHMeta?.alias || [],
    redirect: extratoihF7J98NrHMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/financeiro/extrato.vue").then(m => m.default || m)
  },
  {
    name: index8iiswOvHa9Meta?.name ?? "painel-financeiro",
    path: index8iiswOvHa9Meta?.path ?? "/painel/financeiro",
    meta: index8iiswOvHa9Meta || {},
    alias: index8iiswOvHa9Meta?.alias || [],
    redirect: index8iiswOvHa9Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/financeiro/index.vue").then(m => m.default || m)
  },
  {
    name: recargaoDiQmeLXD6Meta?.name ?? "painel-financeiro-recarga",
    path: recargaoDiQmeLXD6Meta?.path ?? "/painel/financeiro/recarga",
    meta: recargaoDiQmeLXD6Meta || {},
    alias: recargaoDiQmeLXD6Meta?.alias || [],
    redirect: recargaoDiQmeLXD6Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/financeiro/recarga.vue").then(m => m.default || m)
  },
  {
    name: index4zvfyrDpQuMeta?.name ?? "painel",
    path: index4zvfyrDpQuMeta?.path ?? "/painel",
    meta: index4zvfyrDpQuMeta || {},
    alias: index4zvfyrDpQuMeta?.alias || [],
    redirect: index4zvfyrDpQuMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/index.vue").then(m => m.default || m)
  },
  {
    name: configvWXk4MTi2CMeta?.name ?? "painel-org-id-bar-id_bar-config",
    path: configvWXk4MTi2CMeta?.path ?? "/painel/org/:id()/bar/:id_bar()/config",
    meta: configvWXk4MTi2CMeta || {},
    alias: configvWXk4MTi2CMeta?.alias || [],
    redirect: configvWXk4MTi2CMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/org/[id]/bar/[id_bar]/config.vue").then(m => m.default || m)
  },
  {
    name: equiped1gQAKJkfWMeta?.name ?? "painel-org-id-bar-id_bar-equipe",
    path: equiped1gQAKJkfWMeta?.path ?? "/painel/org/:id()/bar/:id_bar()/equipe",
    meta: equiped1gQAKJkfWMeta || {},
    alias: equiped1gQAKJkfWMeta?.alias || [],
    redirect: equiped1gQAKJkfWMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/org/[id]/bar/[id_bar]/equipe.vue").then(m => m.default || m)
  },
  {
    name: estoque4bX0nZV4lUMeta?.name ?? "painel-org-id-bar-id_bar-estoque",
    path: estoque4bX0nZV4lUMeta?.path ?? "/painel/org/:id()/bar/:id_bar()/estoque",
    meta: estoque4bX0nZV4lUMeta || {},
    alias: estoque4bX0nZV4lUMeta?.alias || [],
    redirect: estoque4bX0nZV4lUMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/org/[id]/bar/[id_bar]/estoque.vue").then(m => m.default || m)
  },
  {
    name: indexkYCCGXnML6Meta?.name ?? "painel-org-id-bar-id_bar",
    path: indexkYCCGXnML6Meta?.path ?? "/painel/org/:id()/bar/:id_bar()",
    meta: indexkYCCGXnML6Meta || {},
    alias: indexkYCCGXnML6Meta?.alias || [],
    redirect: indexkYCCGXnML6Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/org/[id]/bar/[id_bar]/index.vue").then(m => m.default || m)
  },
  {
    name: nfcRhyy64SDXPMeta?.name ?? "painel-org-id-bar-id_bar-nfc",
    path: nfcRhyy64SDXPMeta?.path ?? "/painel/org/:id()/bar/:id_bar()/nfc",
    meta: nfcRhyy64SDXPMeta || {},
    alias: nfcRhyy64SDXPMeta?.alias || [],
    redirect: nfcRhyy64SDXPMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/org/[id]/bar/[id_bar]/nfc.vue").then(m => m.default || m)
  },
  {
    name: pedidosHfU8sT6evPMeta?.name ?? "painel-org-id-bar-id_bar-pedidos",
    path: pedidosHfU8sT6evPMeta?.path ?? "/painel/org/:id()/bar/:id_bar()/pedidos",
    meta: pedidosHfU8sT6evPMeta || {},
    alias: pedidosHfU8sT6evPMeta?.alias || [],
    redirect: pedidosHfU8sT6evPMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/org/[id]/bar/[id_bar]/pedidos.vue").then(m => m.default || m)
  },
  {
    name: produtosi20rQ067iuMeta?.name ?? "painel-org-id-bar-id_bar-produtos",
    path: produtosi20rQ067iuMeta?.path ?? "/painel/org/:id()/bar/:id_bar()/produtos",
    meta: produtosi20rQ067iuMeta || {},
    alias: produtosi20rQ067iuMeta?.alias || [],
    redirect: produtosi20rQ067iuMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/org/[id]/bar/[id_bar]/produtos.vue").then(m => m.default || m)
  },
  {
    name: addLLsyfNtS8fMeta?.name ?? "painel-org-id-bares-add",
    path: addLLsyfNtS8fMeta?.path ?? "/painel/org/:id()/bares/add",
    meta: addLLsyfNtS8fMeta || {},
    alias: addLLsyfNtS8fMeta?.alias || [],
    redirect: addLLsyfNtS8fMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/org/[id]/bares/add.vue").then(m => m.default || m)
  },
  {
    name: indexTw3NymArFzMeta?.name ?? "painel-org-id-bares",
    path: indexTw3NymArFzMeta?.path ?? "/painel/org/:id()/bares",
    meta: indexTw3NymArFzMeta || {},
    alias: indexTw3NymArFzMeta?.alias || [],
    redirect: indexTw3NymArFzMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/org/[id]/bares/index.vue").then(m => m.default || m)
  },
  {
    name: add0BWmCMWOudMeta?.name ?? "painel-org-id-comercio-id_comercio-cardapio-add",
    path: add0BWmCMWOudMeta?.path ?? "/painel/org/:id()/comercio/:id_comercio()/cardapio/add",
    meta: add0BWmCMWOudMeta || {},
    alias: add0BWmCMWOudMeta?.alias || [],
    redirect: add0BWmCMWOudMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/org/[id]/comercio/[id_comercio]/cardapio/add.vue").then(m => m.default || m)
  },
  {
    name: indexnqbotXRSctMeta?.name ?? "painel-org-id-comercio-id_comercio-cardapio",
    path: indexnqbotXRSctMeta?.path ?? "/painel/org/:id()/comercio/:id_comercio()/cardapio",
    meta: indexnqbotXRSctMeta || {},
    alias: indexnqbotXRSctMeta?.alias || [],
    redirect: indexnqbotXRSctMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/org/[id]/comercio/[id_comercio]/cardapio/index.vue").then(m => m.default || m)
  },
  {
    name: configMHPf1Okjk9Meta?.name ?? "painel-org-id-comercio-id_comercio-config",
    path: configMHPf1Okjk9Meta?.path ?? "/painel/org/:id()/comercio/:id_comercio()/config",
    meta: configMHPf1Okjk9Meta || {},
    alias: configMHPf1Okjk9Meta?.alias || [],
    redirect: configMHPf1Okjk9Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/org/[id]/comercio/[id_comercio]/config.vue").then(m => m.default || m)
  },
  {
    name: editarpljlpY0TV4Meta?.name ?? "painel-org-id-comercio-id_comercio-editar",
    path: editarpljlpY0TV4Meta?.path ?? "/painel/org/:id()/comercio/:id_comercio()/editar",
    meta: editarpljlpY0TV4Meta || {},
    alias: editarpljlpY0TV4Meta?.alias || [],
    redirect: editarpljlpY0TV4Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/org/[id]/comercio/[id_comercio]/editar.vue").then(m => m.default || m)
  },
  {
    name: index2WYERBhzSUMeta?.name ?? "painel-org-id-comercio-id_comercio",
    path: index2WYERBhzSUMeta?.path ?? "/painel/org/:id()/comercio/:id_comercio()",
    meta: index2WYERBhzSUMeta || {},
    alias: index2WYERBhzSUMeta?.alias || [],
    redirect: index2WYERBhzSUMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/org/[id]/comercio/[id_comercio]/index.vue").then(m => m.default || m)
  },
  {
    name: addLsvbJK6yImMeta?.name ?? "painel-org-id-comercios-add",
    path: addLsvbJK6yImMeta?.path ?? "/painel/org/:id()/comercios/add",
    meta: addLsvbJK6yImMeta || {},
    alias: addLsvbJK6yImMeta?.alias || [],
    redirect: addLsvbJK6yImMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/org/[id]/comercios/add.vue").then(m => m.default || m)
  },
  {
    name: indexRFl9pdfKErMeta?.name ?? "painel-org-id-comercios",
    path: indexRFl9pdfKErMeta?.path ?? "/painel/org/:id()/comercios",
    meta: indexRFl9pdfKErMeta || {},
    alias: indexRFl9pdfKErMeta?.alias || [],
    redirect: indexRFl9pdfKErMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/org/[id]/comercios/index.vue").then(m => m.default || m)
  },
  {
    name: indexpj2zVkUUbIMeta?.name ?? "painel-org-id-comunicacao",
    path: indexpj2zVkUUbIMeta?.path ?? "/painel/org/:id()/comunicacao",
    meta: indexpj2zVkUUbIMeta || {},
    alias: indexpj2zVkUUbIMeta?.alias || [],
    redirect: indexpj2zVkUUbIMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/org/[id]/comunicacao/index.vue").then(m => m.default || m)
  },
  {
    name: configW3z2aF5a2AMeta?.name ?? "painel-org-id-config",
    path: configW3z2aF5a2AMeta?.path ?? "/painel/org/:id()/config",
    meta: configW3z2aF5a2AMeta || {},
    alias: configW3z2aF5a2AMeta?.alias || [],
    redirect: configW3z2aF5a2AMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/org/[id]/config.vue").then(m => m.default || m)
  },
  {
    name: documentosJJAmKmpLUmMeta?.name ?? "painel-org-id-conta-documentos",
    path: documentosJJAmKmpLUmMeta?.path ?? "/painel/org/:id()/conta/documentos",
    meta: documentosJJAmKmpLUmMeta || {},
    alias: documentosJJAmKmpLUmMeta?.alias || [],
    redirect: documentosJJAmKmpLUmMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/org/[id]/conta/documentos.vue").then(m => m.default || m)
  },
  {
    name: indexVhnntHz4jXMeta?.name ?? "painel-org-id-evento-id_evento-checkin",
    path: indexVhnntHz4jXMeta?.path ?? "/painel/org/:id()/evento/:id_evento()/checkin",
    meta: indexVhnntHz4jXMeta || {},
    alias: indexVhnntHz4jXMeta?.alias || [],
    redirect: indexVhnntHz4jXMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/org/[id]/evento/[id_evento]/checkin/index.vue").then(m => m.default || m)
  },
  {
    name: config1grE2hYwYzMeta?.name ?? "painel-org-id-evento-id_evento-config",
    path: config1grE2hYwYzMeta?.path ?? "/painel/org/:id()/evento/:id_evento()/config",
    meta: config1grE2hYwYzMeta || {},
    alias: config1grE2hYwYzMeta?.alias || [],
    redirect: config1grE2hYwYzMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/org/[id]/evento/[id_evento]/config.vue").then(m => m.default || m)
  },
  {
    name: addaxfbpMiRxKMeta?.name ?? "painel-org-id-evento-id_evento-cupons-add",
    path: addaxfbpMiRxKMeta?.path ?? "/painel/org/:id()/evento/:id_evento()/cupons/add",
    meta: addaxfbpMiRxKMeta || {},
    alias: addaxfbpMiRxKMeta?.alias || [],
    redirect: addaxfbpMiRxKMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/org/[id]/evento/[id_evento]/cupons/add.vue").then(m => m.default || m)
  },
  {
    name: _91id_cupom_93puf2HjdmwlMeta?.name ?? "painel-org-id-evento-id_evento-cupons-editar-id_cupom",
    path: _91id_cupom_93puf2HjdmwlMeta?.path ?? "/painel/org/:id()/evento/:id_evento()/cupons/editar/:id_cupom()",
    meta: _91id_cupom_93puf2HjdmwlMeta || {},
    alias: _91id_cupom_93puf2HjdmwlMeta?.alias || [],
    redirect: _91id_cupom_93puf2HjdmwlMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/org/[id]/evento/[id_evento]/cupons/editar/[id_cupom].vue").then(m => m.default || m)
  },
  {
    name: indexzCTy21aqlhMeta?.name ?? "painel-org-id-evento-id_evento-cupons",
    path: indexzCTy21aqlhMeta?.path ?? "/painel/org/:id()/evento/:id_evento()/cupons",
    meta: indexzCTy21aqlhMeta || {},
    alias: indexzCTy21aqlhMeta?.alias || [],
    redirect: indexzCTy21aqlhMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/org/[id]/evento/[id_evento]/cupons/index.vue").then(m => m.default || m)
  },
  {
    name: editarZf334ZnpyiMeta?.name ?? "painel-org-id-evento-id_evento-editar",
    path: editarZf334ZnpyiMeta?.path ?? "/painel/org/:id()/evento/:id_evento()/editar",
    meta: editarZf334ZnpyiMeta || {},
    alias: editarZf334ZnpyiMeta?.alias || [],
    redirect: editarZf334ZnpyiMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/org/[id]/evento/[id_evento]/editar.vue").then(m => m.default || m)
  },
  {
    name: historicoxSpBBWefJgMeta?.name ?? "painel-org-id-evento-id_evento-financeiro-historico",
    path: historicoxSpBBWefJgMeta?.path ?? "/painel/org/:id()/evento/:id_evento()/financeiro/historico",
    meta: historicoxSpBBWefJgMeta || {},
    alias: historicoxSpBBWefJgMeta?.alias || [],
    redirect: historicoxSpBBWefJgMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/org/[id]/evento/[id_evento]/financeiro/historico.vue").then(m => m.default || m)
  },
  {
    name: indexYvMGntbFSCMeta?.name ?? "painel-org-id-evento-id_evento-financeiro",
    path: indexYvMGntbFSCMeta?.path ?? "/painel/org/:id()/evento/:id_evento()/financeiro",
    meta: indexYvMGntbFSCMeta || {},
    alias: indexYvMGntbFSCMeta?.alias || [],
    redirect: indexYvMGntbFSCMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/org/[id]/evento/[id_evento]/financeiro/index.vue").then(m => m.default || m)
  },
  {
    name: indexnDk5as1xkAMeta?.name ?? "painel-org-id-evento-id_evento",
    path: indexnDk5as1xkAMeta?.path ?? "/painel/org/:id()/evento/:id_evento()",
    meta: indexnDk5as1xkAMeta || {},
    alias: indexnDk5as1xkAMeta?.alias || [],
    redirect: indexnDk5as1xkAMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/org/[id]/evento/[id_evento]/index.vue").then(m => m.default || m)
  },
  {
    name: addPn4vKNUrd9Meta?.name ?? "painel-org-id-evento-id_evento-ingressos-add",
    path: addPn4vKNUrd9Meta?.path ?? "/painel/org/:id()/evento/:id_evento()/ingressos/add",
    meta: addPn4vKNUrd9Meta || {},
    alias: addPn4vKNUrd9Meta?.alias || [],
    redirect: addPn4vKNUrd9Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/org/[id]/evento/[id_evento]/ingressos/add.vue").then(m => m.default || m)
  },
  {
    name: _91id_ingresso_93B7Ul2JVumZMeta?.name ?? "painel-org-id-evento-id_evento-ingressos-editar-id_ingresso",
    path: _91id_ingresso_93B7Ul2JVumZMeta?.path ?? "/painel/org/:id()/evento/:id_evento()/ingressos/editar/:id_ingresso()",
    meta: _91id_ingresso_93B7Ul2JVumZMeta || {},
    alias: _91id_ingresso_93B7Ul2JVumZMeta?.alias || [],
    redirect: _91id_ingresso_93B7Ul2JVumZMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/org/[id]/evento/[id_evento]/ingressos/editar/[id_ingresso].vue").then(m => m.default || m)
  },
  {
    name: indexuIFaoGHbubMeta?.name ?? "painel-org-id-evento-id_evento-ingressos",
    path: indexuIFaoGHbubMeta?.path ?? "/painel/org/:id()/evento/:id_evento()/ingressos",
    meta: indexuIFaoGHbubMeta || {},
    alias: indexuIFaoGHbubMeta?.alias || [],
    redirect: indexuIFaoGHbubMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/org/[id]/evento/[id_evento]/ingressos/index.vue").then(m => m.default || m)
  },
  {
    name: integracoesphgQWoAfkmMeta?.name ?? "painel-org-id-evento-id_evento-integracoes",
    path: integracoesphgQWoAfkmMeta?.path ?? "/painel/org/:id()/evento/:id_evento()/integracoes",
    meta: integracoesphgQWoAfkmMeta || {},
    alias: integracoesphgQWoAfkmMeta?.alias || [],
    redirect: integracoesphgQWoAfkmMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/org/[id]/evento/[id_evento]/integracoes.vue").then(m => m.default || m)
  },
  {
    name: email2KsQJuwgutMeta?.name ?? "painel-org-id-evento-id_evento-participantes-email",
    path: email2KsQJuwgutMeta?.path ?? "/painel/org/:id()/evento/:id_evento()/participantes/email",
    meta: email2KsQJuwgutMeta || {},
    alias: email2KsQJuwgutMeta?.alias || [],
    redirect: email2KsQJuwgutMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/org/[id]/evento/[id_evento]/participantes/email.vue").then(m => m.default || m)
  },
  {
    name: indexc52B41BvMQMeta?.name ?? "painel-org-id-evento-id_evento-participantes",
    path: indexc52B41BvMQMeta?.path ?? "/painel/org/:id()/evento/:id_evento()/participantes",
    meta: indexc52B41BvMQMeta || {},
    alias: indexc52B41BvMQMeta?.alias || [],
    redirect: indexc52B41BvMQMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/org/[id]/evento/[id_evento]/participantes/index.vue").then(m => m.default || m)
  },
  {
    name: preferenciasK77pg4EtLSMeta?.name ?? "painel-org-id-evento-id_evento-preferencias",
    path: preferenciasK77pg4EtLSMeta?.path ?? "/painel/org/:id()/evento/:id_evento()/preferencias",
    meta: preferenciasK77pg4EtLSMeta || {},
    alias: preferenciasK77pg4EtLSMeta?.alias || [],
    redirect: preferenciasK77pg4EtLSMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/org/[id]/evento/[id_evento]/preferencias.vue").then(m => m.default || m)
  },
  {
    name: add0eU2CF7zXmMeta?.name ?? "painel-org-id-eventos-add",
    path: add0eU2CF7zXmMeta?.path ?? "/painel/org/:id()/eventos/add",
    meta: add0eU2CF7zXmMeta || {},
    alias: add0eU2CF7zXmMeta?.alias || [],
    redirect: add0eU2CF7zXmMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/org/[id]/eventos/add.vue").then(m => m.default || m)
  },
  {
    name: indexdK3HQeP289Meta?.name ?? "painel-org-id-eventos",
    path: indexdK3HQeP289Meta?.path ?? "/painel/org/:id()/eventos",
    meta: indexdK3HQeP289Meta || {},
    alias: indexdK3HQeP289Meta?.alias || [],
    redirect: indexdK3HQeP289Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/org/[id]/eventos/index.vue").then(m => m.default || m)
  },
  {
    name: indexdKj6PymhY1Meta?.name ?? "painel-org-id-financeiro-extrato",
    path: indexdKj6PymhY1Meta?.path ?? "/painel/org/:id()/financeiro/extrato",
    meta: indexdKj6PymhY1Meta || {},
    alias: indexdKj6PymhY1Meta?.alias || [],
    redirect: indexdKj6PymhY1Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/org/[id]/financeiro/extrato/index.vue").then(m => m.default || m)
  },
  {
    name: indexIfZkta3rYRMeta?.name ?? "painel-org-id-financeiro",
    path: indexIfZkta3rYRMeta?.path ?? "/painel/org/:id()/financeiro",
    meta: indexIfZkta3rYRMeta || {},
    alias: indexIfZkta3rYRMeta?.alias || [],
    redirect: indexIfZkta3rYRMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/org/[id]/financeiro/index.vue").then(m => m.default || m)
  },
  {
    name: indexSgPZUMeb6MMeta?.name ?? "painel-org-id-financeiro-saques",
    path: indexSgPZUMeb6MMeta?.path ?? "/painel/org/:id()/financeiro/saques",
    meta: indexSgPZUMeb6MMeta || {},
    alias: indexSgPZUMeb6MMeta?.alias || [],
    redirect: indexSgPZUMeb6MMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/org/[id]/financeiro/saques/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_venda_93aRzTeha3HkMeta?.name ?? "painel-org-id-financeiro-vendas-id_venda",
    path: _91id_venda_93aRzTeha3HkMeta?.path ?? "/painel/org/:id()/financeiro/vendas/:id_venda()",
    meta: _91id_venda_93aRzTeha3HkMeta || {},
    alias: _91id_venda_93aRzTeha3HkMeta?.alias || [],
    redirect: _91id_venda_93aRzTeha3HkMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/org/[id]/financeiro/vendas/[id_venda].vue").then(m => m.default || m)
  },
  {
    name: indexfiNVcUgN6PMeta?.name ?? "painel-org-id-financeiro-vendas",
    path: indexfiNVcUgN6PMeta?.path ?? "/painel/org/:id()/financeiro/vendas",
    meta: indexfiNVcUgN6PMeta || {},
    alias: indexfiNVcUgN6PMeta?.alias || [],
    redirect: indexfiNVcUgN6PMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/org/[id]/financeiro/vendas/index.vue").then(m => m.default || m)
  },
  {
    name: indexQAdtaf5TRqMeta?.name ?? "painel-org-id",
    path: indexQAdtaf5TRqMeta?.path ?? "/painel/org/:id()",
    meta: indexQAdtaf5TRqMeta || {},
    alias: indexQAdtaf5TRqMeta?.alias || [],
    redirect: indexQAdtaf5TRqMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/org/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: indexoLg7RAfijaMeta?.name ?? "painel-org-id-integracoes",
    path: indexoLg7RAfijaMeta?.path ?? "/painel/org/:id()/integracoes",
    meta: indexoLg7RAfijaMeta || {},
    alias: indexoLg7RAfijaMeta?.alias || [],
    redirect: indexoLg7RAfijaMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/org/[id]/integracoes/index.vue").then(m => m.default || m)
  },
  {
    name: addyMJxC3NlG9Meta?.name ?? "painel-org-id-locais-add",
    path: addyMJxC3NlG9Meta?.path ?? "/painel/org/:id()/locais/add",
    meta: addyMJxC3NlG9Meta || {},
    alias: addyMJxC3NlG9Meta?.alias || [],
    redirect: addyMJxC3NlG9Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/org/[id]/locais/add.vue").then(m => m.default || m)
  },
  {
    name: indexn5WgFWtuL0Meta?.name ?? "painel-org-id-locais",
    path: indexn5WgFWtuL0Meta?.path ?? "/painel/org/:id()/locais",
    meta: indexn5WgFWtuL0Meta || {},
    alias: indexn5WgFWtuL0Meta?.alias || [],
    redirect: indexn5WgFWtuL0Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/org/[id]/locais/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_pedido_934jq3jkYBw6Meta?.name ?? "painel-org-id-pedidos-id_pedido",
    path: _91id_pedido_934jq3jkYBw6Meta?.path ?? "/painel/org/:id()/pedidos/:id_pedido()",
    meta: _91id_pedido_934jq3jkYBw6Meta || {},
    alias: _91id_pedido_934jq3jkYBw6Meta?.alias || [],
    redirect: _91id_pedido_934jq3jkYBw6Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/org/[id]/pedidos/[id_pedido].vue").then(m => m.default || m)
  },
  {
    name: indexki02SufrMCMeta?.name ?? "painel-org-id-pedidos",
    path: indexki02SufrMCMeta?.path ?? "/painel/org/:id()/pedidos",
    meta: indexki02SufrMCMeta || {},
    alias: indexki02SufrMCMeta?.alias || [],
    redirect: indexki02SufrMCMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/org/[id]/pedidos/index.vue").then(m => m.default || m)
  },
  {
    name: _91ticket_id_93x3sopNe1prMeta?.name ?? "painel-org-id-suporte-ticket_id",
    path: _91ticket_id_93x3sopNe1prMeta?.path ?? "/painel/org/:id()/suporte/:ticket_id()",
    meta: _91ticket_id_93x3sopNe1prMeta || {},
    alias: _91ticket_id_93x3sopNe1prMeta?.alias || [],
    redirect: _91ticket_id_93x3sopNe1prMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/org/[id]/suporte/[ticket_id].vue").then(m => m.default || m)
  },
  {
    name: indexdid5JBdLeOMeta?.name ?? "painel-org-id-suporte",
    path: indexdid5JBdLeOMeta?.path ?? "/painel/org/:id()/suporte",
    meta: indexdid5JBdLeOMeta || {},
    alias: indexdid5JBdLeOMeta?.alias || [],
    redirect: indexdid5JBdLeOMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/org/[id]/suporte/index.vue").then(m => m.default || m)
  },
  {
    name: addkyI3YaxaZ5Meta?.name ?? "painel-org-add",
    path: addkyI3YaxaZ5Meta?.path ?? "/painel/org/add",
    meta: addkyI3YaxaZ5Meta || {},
    alias: addkyI3YaxaZ5Meta?.alias || [],
    redirect: addkyI3YaxaZ5Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/org/add.vue").then(m => m.default || m)
  },
  {
    name: suporte7NWhQTjWn1Meta?.name ?? "painel-suporte",
    path: suporte7NWhQTjWn1Meta?.path ?? "/painel/suporte",
    meta: suporte7NWhQTjWn1Meta || {},
    alias: suporte7NWhQTjWn1Meta?.alias || [],
    redirect: suporte7NWhQTjWn1Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/painel/suporte.vue").then(m => m.default || m)
  },
  {
    name: dadosARNg6LKW21Meta?.name ?? "perfil-dados",
    path: dadosARNg6LKW21Meta?.path ?? "/perfil/dados",
    meta: dadosARNg6LKW21Meta || {},
    alias: dadosARNg6LKW21Meta?.alias || [],
    redirect: dadosARNg6LKW21Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/perfil/dados.vue").then(m => m.default || m)
  },
  {
    name: editar5BJg38phDpMeta?.name ?? "perfil-editar",
    path: editar5BJg38phDpMeta?.path ?? "/perfil/editar",
    meta: editar5BJg38phDpMeta || {},
    alias: editar5BJg38phDpMeta?.alias || [],
    redirect: editar5BJg38phDpMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/perfil/editar.vue").then(m => m.default || m)
  },
  {
    name: extrato9F4an1sRirMeta?.name ?? "perfil-extrato",
    path: extrato9F4an1sRirMeta?.path ?? "/perfil/extrato",
    meta: extrato9F4an1sRirMeta || {},
    alias: extrato9F4an1sRirMeta?.alias || [],
    redirect: extrato9F4an1sRirMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/perfil/extrato.vue").then(m => m.default || m)
  },
  {
    name: favoritosCx9ddvGebHMeta?.name ?? "perfil-favoritos",
    path: favoritosCx9ddvGebHMeta?.path ?? "/perfil/favoritos",
    meta: favoritosCx9ddvGebHMeta || {},
    alias: favoritosCx9ddvGebHMeta?.alias || [],
    redirect: favoritosCx9ddvGebHMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/perfil/favoritos.vue").then(m => m.default || m)
  },
  {
    name: indexvl9E5kU77iMeta?.name ?? "perfil",
    path: indexvl9E5kU77iMeta?.path ?? "/perfil",
    meta: indexvl9E5kU77iMeta || {},
    alias: indexvl9E5kU77iMeta?.alias || [],
    redirect: indexvl9E5kU77iMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/perfil/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93UnYx625l00Meta?.name ?? "perfil-ingressos-id",
    path: _91id_93UnYx625l00Meta?.path ?? "/perfil/ingressos/:id()",
    meta: _91id_93UnYx625l00Meta || {},
    alias: _91id_93UnYx625l00Meta?.alias || [],
    redirect: _91id_93UnYx625l00Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/perfil/ingressos/[id].vue").then(m => m.default || m)
  },
  {
    name: indexcBf6q7NfXaMeta?.name ?? "perfil-ingressos",
    path: indexcBf6q7NfXaMeta?.path ?? "/perfil/ingressos",
    meta: indexcBf6q7NfXaMeta || {},
    alias: indexcBf6q7NfXaMeta?.alias || [],
    redirect: indexcBf6q7NfXaMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/perfil/ingressos/index.vue").then(m => m.default || m)
  },
  {
    name: notificacoesW2q1tAfYwaMeta?.name ?? "perfil-notificacoes",
    path: notificacoesW2q1tAfYwaMeta?.path ?? "/perfil/notificacoes",
    meta: notificacoesW2q1tAfYwaMeta || {},
    alias: notificacoesW2q1tAfYwaMeta?.alias || [],
    redirect: notificacoesW2q1tAfYwaMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/perfil/notificacoes.vue").then(m => m.default || m)
  },
  {
    name: _91id_93ZA2mQ6KzYHMeta?.name ?? "perfil-pedidos-id",
    path: _91id_93ZA2mQ6KzYHMeta?.path ?? "/perfil/pedidos/:id()",
    meta: _91id_93ZA2mQ6KzYHMeta || {},
    alias: _91id_93ZA2mQ6KzYHMeta?.alias || [],
    redirect: _91id_93ZA2mQ6KzYHMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/perfil/pedidos/[id].vue").then(m => m.default || m)
  },
  {
    name: indexwmIKiyCcO8Meta?.name ?? "perfil-pedidos",
    path: indexwmIKiyCcO8Meta?.path ?? "/perfil/pedidos",
    meta: indexwmIKiyCcO8Meta || {},
    alias: indexwmIKiyCcO8Meta?.alias || [],
    redirect: indexwmIKiyCcO8Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/perfil/pedidos/index.vue").then(m => m.default || m)
  },
  {
    name: recargaTzbUxVcUyYMeta?.name ?? "perfil-recarga",
    path: recargaTzbUxVcUyYMeta?.path ?? "/perfil/recarga",
    meta: recargaTzbUxVcUyYMeta || {},
    alias: recargaTzbUxVcUyYMeta?.alias || [],
    redirect: recargaTzbUxVcUyYMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/perfil/recarga.vue").then(m => m.default || m)
  },
  {
    name: segurancaEL7YUXohuhMeta?.name ?? "perfil-seguranca",
    path: segurancaEL7YUXohuhMeta?.path ?? "/perfil/seguranca",
    meta: segurancaEL7YUXohuhMeta || {},
    alias: segurancaEL7YUXohuhMeta?.alias || [],
    redirect: segurancaEL7YUXohuhMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/perfil/seguranca.vue").then(m => m.default || m)
  },
  {
    name: suporte9TcKM1paUdMeta?.name ?? "perfil-suporte",
    path: suporte9TcKM1paUdMeta?.path ?? "/perfil/suporte",
    meta: suporte9TcKM1paUdMeta || {},
    alias: suporte9TcKM1paUdMeta?.alias || [],
    redirect: suporte9TcKM1paUdMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/perfil/suporte.vue").then(m => m.default || m)
  },
  {
    name: walletshqp98X6HVMeta?.name ?? "perfil-wallet",
    path: walletshqp98X6HVMeta?.path ?? "/perfil/wallet",
    meta: walletshqp98X6HVMeta || {},
    alias: walletshqp98X6HVMeta?.alias || [],
    redirect: walletshqp98X6HVMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/perfil/wallet.vue").then(m => m.default || m)
  },
  {
    name: politicas_45de_45privacidadeLNpncEhE7TMeta?.name ?? "politicas-de-privacidade",
    path: politicas_45de_45privacidadeLNpncEhE7TMeta?.path ?? "/politicas-de-privacidade",
    meta: politicas_45de_45privacidadeLNpncEhE7TMeta || {},
    alias: politicas_45de_45privacidadeLNpncEhE7TMeta?.alias || [],
    redirect: politicas_45de_45privacidadeLNpncEhE7TMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/politicas-de-privacidade.vue").then(m => m.default || m)
  },
  {
    name: indexDqV3Lxa5AvMeta?.name ?? "search",
    path: indexDqV3Lxa5AvMeta?.path ?? "/search",
    meta: indexDqV3Lxa5AvMeta || {},
    alias: indexDqV3Lxa5AvMeta?.alias || [],
    redirect: indexDqV3Lxa5AvMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/search/index.vue").then(m => m.default || m)
  },
  {
    name: termos_45e_45condicoesbzrt6NyaPIMeta?.name ?? "termos-e-condicoes",
    path: termos_45e_45condicoesbzrt6NyaPIMeta?.path ?? "/termos-e-condicoes",
    meta: termos_45e_45condicoesbzrt6NyaPIMeta || {},
    alias: termos_45e_45condicoesbzrt6NyaPIMeta?.alias || [],
    redirect: termos_45e_45condicoesbzrt6NyaPIMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/termos-e-condicoes.vue").then(m => m.default || m)
  },
  {
    name: _91id_93xOysflTcTtMeta?.name ?? "v-checkout-id",
    path: _91id_93xOysflTcTtMeta?.path ?? "/v/checkout/:id()",
    meta: _91id_93xOysflTcTtMeta || {},
    alias: _91id_93xOysflTcTtMeta?.alias || [],
    redirect: _91id_93xOysflTcTtMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/v/checkout/[id].vue").then(m => m.default || m)
  }
]